import { Subject } from 'rxjs';

export const csvImportFinishedSubject = new Subject();
